import React from 'react';
import CommentViewBase from './CommentViewBase';

export default function QueryCommentView(props) {
    return (
        <CommentViewBase
            {...props}
            mode="query"
            commentRoutePath="/comment"
            includeRecipientSelection={false}
        />
    );
}
